module.exports = __webpack_public_path__ + "static/img/trip.e58b2c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/trip.jpg
// module id = Nyy7
// module chunks = 1